import { useSetAppState } from '../../stores/contexts/AppStateContext';
import { DefaultProps } from '../../types/DefaultProps';
import { FiMenuIcon } from '../Icon';
import { ComponentProps as IconProps } from '../Icon/Icon';

import styles from './HamburgerButton.module.scss';
import { HeaderIconButton } from './HeaderIconButton';

import type { FC, ComponentType, ReactNode } from 'react';

type Props = DefaultProps & {
  icon: ComponentType<IconProps>;
  children?: ReactNode;
};

export const HamburgerButton: FC<Props> = ({ children }) => {
  const setAppState = useSetAppState();

  const openMenuModal = () => {
    setAppState({ isMenuModalShown: true });
  };

  return (
    <button className={styles.wrap} onClick={openMenuModal}>
      <HeaderIconButton icon={FiMenuIcon} data-gtm-click="hamburger-button">
        メニュー
      </HeaderIconButton>
      {children}
    </button>
  );
};
